import React, { useEffect } from 'react';
import './Data.css';
import { Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CachedIcon from '@mui/icons-material/Cached';
import BorderHeading from '../../heading/BorderHeading';
import { openPopup } from "../../../stateManagement/actions/popupActions";

interface DataProps {
  data: any;
  downloadExcel: (data: null) => void;
  expandJsonView: (index: number | string, fieldName: string, data: any) => void;
  resetView: () => void;
  currentPage: number;
  rowsPerPage: number;
  setCount: (count: number) => void;
  resetPage: () => void;
}

const Data = (props: DataProps) => {
  useEffect(() => {
    props.resetPage();
  }, [props.data]);

  useEffect(() => {
    const count = Array.isArray(props.data) ? props.data.length : Object.keys(props.data).length;
    props.setCount(count);
  }, [props.data]);

  const renderValue = (key: string, value: any, actualIndex: number | string, data: any) => {
    if ((key === 'productInfo' || key === 'orderDetails' || key === 'salesDetails' || key==='code') && value!=null ){
      return (
        <td
          className="table-entry cursor-pointer hover:bg-gray-100"
          onClick={() => props.expandJsonView(actualIndex, key, data)}
          style={{
            color: '#2196f3',
            textDecoration: 'underline',
            cursor: 'pointer'
          }}
        >
          Click to expand
        </td>
      );
    }

    if (value && typeof value === 'object') {
      return (
        <td
          className="table-entry"
          onClick={typeof value === 'object' && value !== null ?
            () => props.expandJsonView(actualIndex, key, data) : undefined}
        >
          {JSON.stringify(value)}
        </td>
      );
    }

    return <td className="table-entry">{JSON.stringify(value)}</td>;
  };

  const renderTableRows = (data: any, parentIndex?: number | string) => {
    const start = props.currentPage * props.rowsPerPage;
    const end = start + props.rowsPerPage;
    let rows = Array.isArray(data) ? data.slice(start, end) : data;

    if (!Array.isArray(data)) {
      rows = Object.fromEntries(
        Object.entries(data).slice(start, end)
      );
    }

    return Object.entries(rows).map(([key, value], index) => {
      const actualIndex = parentIndex ?? (start + index);
      const backgroundColor = index % 2 === 0 ? '#f3fcfb' : '#ffffff';

      // If value is an object or array, render its properties
      if (value && typeof value === 'object' && key !== 'productInfo') {
        return (
          <>
            <tr key={`${actualIndex}-${key}-header`} style={{ backgroundColor, fontWeight: 'bold' }}>
              <th colSpan={2}>{key}</th>
            </tr>
            {Object.entries(value).map(([subKey, subValue]) => (
              <tr
                key={`${actualIndex}-${key}-${subKey}`}
                style={{ backgroundColor }}
              >
                <th style={{ paddingLeft: '2em' }}>{subKey}</th>
                {renderValue(subKey, subValue, key, data)}
              </tr>
            ))}
          </>
        );
      }

      // For primitive values and productInfo
      return (
        <tr key={`${actualIndex}-${key}`} style={{ backgroundColor }}>
          <th>{key}</th>
          {renderValue(key, value, actualIndex, data)}
        </tr>
      );
    });
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <BorderHeading>Database</BorderHeading>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<DownloadIcon />}
            sx={{ marginRight: '20px' }}
            onClick={() => props.downloadExcel(props.data)}
          >
            Download
          </Button>
          <Button
                      variant="contained"
                      color="primary"
                      startIcon={<ContentCopyIcon />}
                      sx={{ marginRight: '20px' }}
                      onClick={()=>{
                          navigator.clipboard.writeText(JSON.stringify(props.data));
                      openPopup("Success","Copied Succesfully");}}
                    >
                      Copy
                    </Button>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<CachedIcon />}
            sx={{ marginRight: '20px' }}
            onClick={() => props.resetView()}
          >
            Reset
          </Button>
        </div>
      </div>
      <table style={{ textAlign: 'left', marginLeft: '2%', width: '96%' }}>
        <tbody>
          {renderTableRows(props.data)}
        </tbody>
      </table>
    </div>
  );
};

export default Data;